import axios from "axios";
import { API_URL, getAuthHeader } from ".";
import { EventSponsor } from "../Models/EventSponsor";

class EventSponsorApi {
  static getAll() {
    return axios.get<EventSponsor[]>(
      `${API_URL}/api/eventsponsor`,
      getAuthHeader()
    );
  }

  static getByEventId(eventId: number) {
    return axios.get<EventSponsor[]>(
      `${API_URL}/api/eventsponsor/event/${eventId}`,
      getAuthHeader()
    );
  }

  static getByConferenceId(conferenceId: number) {
    return axios.get<EventSponsor[]>(
      `${API_URL}/api/eventsponsor/conference/${conferenceId}`,
      getAuthHeader()
    );
  }

  static getById(id: number) {
    return axios.get<EventSponsor>(
      `${API_URL}/api/eventsponsor/${id}`,
      getAuthHeader()
    );
  }

  static create(sponsor: EventSponsor) {
    return axios.post<EventSponsor>(
      `${API_URL}/api/eventsponsor`,
      sponsor,
      getAuthHeader()
    );
  }

  static update(sponsor: EventSponsor) {
    return axios.put(
      `${API_URL}/api/eventsponsor/${sponsor.id}`,
      sponsor,
      getAuthHeader()
    );
  }

  static delete(id: number) {
    return axios.delete(`${API_URL}/api/eventsponsor/${id}`, getAuthHeader());
  }
}

export default EventSponsorApi;
